import { defineMessages } from "react-intl";

export const engineAppearanceMessages = defineMessages({
  entityName: {
    id: "engineAppearance.entityName",
    defaultMessage: "Appearance",
  },
  logo: {
    id: "engineAppearance.logo.label",
    defaultMessage: "logo",
  },
  primaryColorLabel: {
    id: "engineAppearance.primaryColor.label",
    defaultMessage: "primaryColor",
  },
  secondaryColorLabel: {
    id: "engineAppearance.secondaryColor.label",
    defaultMessage: "secondaryColor",
  },
  primaryColorHelpText: {
    id: "engineAppearance.primaryColor.helpText",
    defaultMessage: "primaryColor",
  },
  secondaryColorHelpText: {
    id: "engineAppearance.secondaryColor.helpText",
    defaultMessage: "secondaryColor",
  },
  mobileLogo: {
    id: "engineAppearance.mobileLogo.label",
    defaultMessage: "logo",
  },
  emailLogo: {
    id: "engineAppearance.emailLogo.label",
    defaultMessage: "logo",
  },
  favicon: {
    id: "engineAppearance.favicon.label",
    defaultMessage: "logo",
  },
  engineAppearanceJsonLabel: {
    id: "engineAppearance.json.label",
    defaultMessage: "json",
  },
  engineAppearanceJsonHelpText: {
    id: "engineAppearance.json.helpText",
    defaultMessage: "Please do not remove any property",
  },
  faviconHelpText: {
    id: "engineAppearance.favicon.helpText",
    defaultMessage: "Tamaño: 16x16.",
  },
  logoHelpText: {
    id: "engineAppearance.logo.helpText",
    defaultMessage: "Tamaño 800x232px",
  },
});
